"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const litigation_1 = require("@/pages/index/select/litigation");
const file_1 = require("@/pages/index/utils/file");
const litigation_2 = __importDefault(require("@/pages/index/api/litigation"));
const LitigationEdit_vue_1 = __importDefault(require("./../../components/LitigationEdit.vue"));
const utils_1 = require("@/config/utils");
const litigationLogFlowConfig_1 = __importStar(require("../litigationLogFlowConfig"));
const ApplicationInfo_vue_1 = __importDefault(require("./../../components/ApplicationInfo.vue"));
const ContractArea_vue_1 = __importDefault(require("./../../components/ContractArea.vue"));
const CollectionList_vue_1 = __importDefault(require("./../../components/CollectionList.vue"));
const FlowList_vue_1 = __importDefault(require("./../../components/FlowList.vue"));
const AuctionList_vue_1 = __importDefault(require("./../../components/AuctionList.vue"));
const MediateList_vue_1 = __importDefault(require("./../../components/MediateList.vue"));
const OperateList_vue_1 = __importDefault(require("./../../components/OperateList.vue"));
const mainData_1 = __importDefault(require("./../mainData"));
let fromPath = '';
exports.default = (0, vue_1.defineComponent)({
    name: 'LitigationApplicationInfo',
    components: {
        LitigationEdit: LitigationEdit_vue_1.default,
        ApplicationInfo: ApplicationInfo_vue_1.default,
        ContractArea: ContractArea_vue_1.default,
        CollectionList: CollectionList_vue_1.default,
        FlowList: FlowList_vue_1.default,
        AuctionList: AuctionList_vue_1.default,
        MediateList: MediateList_vue_1.default,
        OperateList: OperateList_vue_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: undefined,
            applyLitigationId: undefined,
            next: undefined,
            overdueRecord: undefined,
            flow: {
                data: litigationLogFlowConfig_1.default,
                key: undefined
            }
        };
    },
    beforeRouteEnter(to, from) {
        // 在渲染该组件的对应路由被验证前调用
        // 不能获取组件实例 `this` ！
        // 因为当守卫执行时，组件实例还没被创建！
        fromPath = from.fullPath !== '/' ? from.fullPath : '';
    },
    computed: {
        id() {
            return this.$route.params.id === 'build' ? undefined : this.$route.params.id;
        },
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        currentParams() {
            const params = this.$route.params;
            return {
                flowKey: (0, utils_1.simpleDecrypt)(params.flowKey)
            };
        },
        currentOverdueRecordId() {
            if (this.$route.params.overdueRecordId && this.$route.params.overdueRecordId !== 'auto') {
                return this.$route.params.overdueRecordId;
            }
            else if (this.detail) {
                return this.detail.overdueRecordId;
            }
            else {
                return undefined;
            }
        },
        process() {
            return this.detail ? Number(this.detail.litigationStatus.value) : 0;
        },
        isFinished() {
            return this.process >= 100;
        }
    },
    watch: {
        id() {
            this.$nextTick(() => {
                this.init();
            });
        },
        currentOverdueRecordId() {
            this.overdueRecord = undefined;
        },
        $route: {
            deep: true,
            handler() {
                this.init();
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        onContractLoad(record) {
            this.overdueRecord = record;
            this.applyLitigationId = record.applyLitigationId;
            if (!this.id) {
                // 新增
                const currentFormData = this.$refs['litigation-edit'].$refs['edit-form'].currentForm.getData();
                currentFormData.waitCollectRent = record.residueRent;
                currentFormData.waitCollectPrincipal = record.residueCorpus;
                currentFormData.waitCollectInterest = record.residueInterest;
            }
        },
        init(key) {
            this.detail = undefined;
            const flowEdit = this.$refs['litigation-edit'];
            if (this.id) {
                (0, file_1.getFileWithPromise)(litigation_2.default.litigationLogInfo.require({
                    id: this.id
                }), this.id, 'litigationLog').then(res => {
                    const detail = this.mainData.$createDataByDictionary(res.data);
                    detail.fileList = [];
                    if (res.file) {
                        res.file.forEach(item => {
                            detail.fileList.push(item);
                        });
                    }
                    this.detail = detail;
                    this.flow.key = key || this.currentParams.flowKey;
                    this.next = litigation_1.logStatus.getNext(this.detail.litigationStatus.process);
                    flowEdit.init(this.flow.key, this.detail);
                });
            }
            else {
                this.next = litigation_1.logStatus.getNext();
                flowEdit.init();
            }
        },
        onReload() {
            (0, litigationLogFlowConfig_1.toLitigationLog)(this.$route.params.id, 'end', this.$route.params.overdueRecordId, true);
            // this.init('100')
        },
        onBack(toFrom) {
            if (fromPath && toFrom) {
                // 存在来源路径切需要跳转回来源时，通过back回退
                this.$router.replace(fromPath);
            }
            else {
                this.$router.replace('/litigation/log');
            }
        }
    }
});
